export default {
  SET_AUCTIONS_LIST(state, payload) {
    state.list = (payload.documentos || [])
      .map((batch) => ({ ...batch, selected: false }))
      .reduce((index, option) => ({
        ...index,
        [option.subastaId]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_AUCTIONS_BATCHES_HISTORY_LIST(state, payload) {
    state.listHistory = (payload.documentos || [])
      .map((batch) => ({ ...batch, selected: false }))
      .reduce((index, option) => ({
        ...index,
        [option.loteId]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_SELECTED_AUCTION(state, payload) {
    state.selectedAuction = payload;
  },
  SET_SELECTED_AUCTION_BATCHES(state, payload) {
    state.selectedAuctionBatches = payload;
  },
  REMOVE_SELECTED_AUCTION_BATCHES(state, lotesIdRemove) {
    state.selectedAuctionBatches = {
      ...state.selectedAuctionBatches,
      documentos: state.selectedAuctionBatches.documentos
        .filter((batches) => !lotesIdRemove.includes(batches.loteId))
    };
  },
  UPDATE_AUCTION_LIST_STATUS(state, { subasta }) {
    state.list[subasta.subastaId].estado = subasta.estado;
  },
  MARK_SELECTED_AUCTIONS(state, isSelected) {
    state.list = Object.values(state.list).map((element) => ({
      ...element,
      selected: isSelected
    }));
  }
};
